import { __awaiter } from "tslib";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
export const downloadExcel = (doc) => __awaiter(void 0, void 0, void 0, function* () {
    const workbook = createWorkbook();
    doc.sheets.forEach((sheet) => {
        const ws = workbook.addWorksheet(sheet.title);
        // If there are top info rows, add them to the top of the sheet
        if (sheet.topInfoRows) {
            // Add the top info rows
            for (let i = 0; i < sheet.topInfoRows.length; i++) {
                ws.getCell(`A${i + 1}`).value = '' + sheet.topInfoRows[i];
            }
            // leave one row as a gap then add header row
            ws.getRow(sheet.topInfoRows.length + 2).values = sheet.headers.flatMap((h) => h.header);
            const keys = [];
            for (let i = 0; i < sheet.headers.length; i++) {
                keys.push({ key: sheet.headers[i].key, width: sheet.headers[i].width });
            }
            ws.columns = keys;
        }
        else {
            // Otherwise, just add the headers
            ws.columns = sheet.headers;
        }
        // Now add the data rows
        sheet.data.forEach((row) => ws.addRow(row));
    });
    saveAs(yield workbookToBlob(workbook), doc.name);
});
export const createWorkbook = () => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Tumelo';
    workbook.lastModifiedBy = 'Tumelo';
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();
    return workbook;
};
export const workbookToBlob = (workbook) => __awaiter(void 0, void 0, void 0, function* () {
    const buf = yield workbook.xlsx.writeBuffer();
    return new Blob([buf]);
});
